// src/pages/TenantManagement/modals/DeleteTenantDialog.tsx
import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Alert,
} from 'reactstrap';
import { useLocation } from 'react-router-dom';

// Types
import { Tenant } from '../types';
import { PageActionPermission } from 'services/pageActionPermission/PageActionPermission';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('tenant_management');

interface DeleteTenantDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
  tenant: Tenant | null;
}

const DeleteTenantDialog: React.FC<DeleteTenantDialogProps> = ({
  isOpen,
  onClose,
  onDelete,
  tenant,
}) => {
  const location = useLocation();
  if (!tenant) return null;

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>
        <i className="ri-delete-bin-line text-danger me-2"></i>
        {st('xac_nhan_xoa_don_vi_title')}
      </ModalHeader>
      <ModalBody>
        <Alert color="warning" className="mb-3">
          <i className="ri-alert-line me-2"></i>
          <strong>{st('canh_bao_text')}</strong> {st('hanh_dong_nay_khong_the_hoan_message')}
        </Alert>

        <p className="mb-3">
          {st('ban_co_chac_chan_muon_xoa_text')}
        </p>

        <div className="bg-light p-3 rounded">
          <div className="mb-2">
            <strong>{st('ma_text')}</strong> <span className="text-primary">{tenant.code}</span>
          </div>
          <div className="mb-2">
            <strong>{st('ten_text')}</strong> {tenant.name}
          </div>
          {tenant.description && (
            <div className="mb-2">
              <strong>{st('mo_ta_text')}</strong> {tenant.description}
            </div>
          )}
          {tenant.parentName && (
            <div>
              <strong>{st('thuoc_don_vi_text')}</strong> {tenant.parentName}
            </div>
          )}
        </div>

                {tenant.parentId && (
          <Alert color="info" className="mt-3 mb-0">
            <i className="ri-information-line me-2"></i>
            {st('don_vi_nay_thuoc_don_vi_message')} <strong>{tenant.parentName}</strong>
          </Alert>
        )}
        
        {tenant.employeeCount > 0 && (
          <Alert color="danger" className="mt-3 mb-0">
            <i className="ri-error-warning-line me-2"></i>
            {st('don_vi_nay_co_message')} <strong>{tenant.employeeCount}</strong> {st('nhan_vien_xoa_don_vi_se_message')}
          </Alert>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={onClose}>
          <i className="ri-close-line me-1"></i>
          {st('huy_bo_button')}
        </Button>
        {PageActionPermission.canDisplay(location.pathname, "button-delete-confirm") && (
        <Button
          color="danger"
          data-action-code="button-delete-confirm"
          data-action-name="Xác nhận xóa đơn vị"
          onClick={onDelete}
        >
          <i className="ri-delete-bin-line me-1"></i>
          {st('xoa_don_vi_button')}
        </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default DeleteTenantDialog;